/**
 * @packageDocumentation
 * @module      LoggedInUser.ts
 * @description Encapsulates information about the user who is logged in.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import UserDetails, { RoleName } from "./UserDetails";
import CloudApi from "./CloudApi";
import Fetcher from "./Fetcher";
let loggedInUserFetcher = new Fetcher();
export { loggedInUserFetcher };
/**
 * A static class (or the closest thing that TypeScript has to one) that encapsulates information
 * about the user who is logged in.
 */
class LoggedInUser {
    /** Make it look like we have logged in as the given user */
    static forceLogin(userDetails) {
        LoggedInUser.userDetails = userDetails;
        LoggedInUser.accessToken = "UsedOnlyinTests-DummyAccessToken";
    }
    /** Make it look like the user has logged out. */
    static forceLogOut() {
        LoggedInUser.userDetails = undefined;
        LoggedInUser.accessToken = undefined;
    }
    static isRoboticNetworkAdmin() {
        return LoggedInUser.hasRole(RoleName.RoboticNetworkAdmin);
    }
    static isAudit() {
        return LoggedInUser.hasRole(RoleName.Audit);
    }
    static hasRole(roleName) {
        var _a, _b;
        return !!((_a = LoggedInUser.userDetails) === null || _a === void 0 ? void 0 : _a.roles) && ((_b = LoggedInUser.userDetails) === null || _b === void 0 ? void 0 : _b.roles.some(r => {
            return r.roleName == roleName;
        }));
    }
    static populateLoggedInUser(username, fullname, accessToken) {
        LoggedInUser.userDetails = new UserDetails();
        LoggedInUser.userDetails.username = username;
        LoggedInUser.userDetails.name = fullname;
        LoggedInUser.accessToken = accessToken;
        return new CloudApi(loggedInUserFetcher).fetchRolesFromAccessToken().then((roles) => {
            LoggedInUser.userDetails.roles.push(...roles);
        });
    }
    /**
     * No-op. The only purpose of this private constructor is to guarantee that
     * this class only has static members. (This is TypeScript's best approximation
     * to a static class.)
     * @private
     */
    constructor() {
    }
}
LoggedInUser.accessToken = undefined;
LoggedInUser.userDetails = undefined;
export default LoggedInUser;
//# sourceMappingURL=LoggedInUser.js.map